import { Colors } from '../../consts/Colors';
import { Scales } from '../../consts/Scales';
import TraductionManager from '../TraductionManager.js';
export default class Answer extends Phaser.GameObjects.Container {
    constructor(
        scene,
        x,
        y,
        infos,
        solo,
        large,

        width = this.scene.game.data.langue === 'tha' || this.scene.game.data.langue === 'jap'
            ? 700 * Scales.scaleX
            : 500 * Scales.scaleX,
    ) {
        super(scene, x, y, []);

        this.traductionManager = new TraductionManager();
        this.scene = scene;
        scene.add.existing(this);

        this.isTrue = infos.isTrue;
        this.isSelected = false;
        this.isSolo = solo;
        this.large = large;

        this.backWidth = width;
        this.backHeight = 80 * Scales.scaleY;
        this.fontSize =
            this.scene.game.data.langue === 'tha' || this.scene.game.data.langue === 'jap'
                ? `${24 * Scales.scaleX}px`
                : `${28 * Scales.scaleX}px`;
        if (this.isSolo === false) {
            this.backWidth = 300 * Scales.scaleX;
            this.backHeight = 80 * Scales.scaleY;
            this.fontSize = `${28 * Scales.scaleX}px`;
        }

        if (this.large) {
            // this.backWidth = 560
            this.backHeight = 80 * Scales.scaleY;
            this.fontSize = `${24 * Scales.scaleX}px`;
        }

        if (infos.text.length > 100) {
            this.fontSize = `${24 * Scales.scaleX}px`;
        }

        console.log('Current Answer:', this.traductionManager.getText(infos.text));
        let ans = {
            text: this.traductionManager.getText(infos.text),
            config: {
                size: this.fontSize,
                fontFamily:
                    'DMSansMedium, "NotoSansJP", "NotoSansArabic", "NotoSansThai", sans-serif',
                align: this.scene.game.data.langue === 'ara' ? 'right' : 'center',
                color: Colors.Text.DarkBlue,
                backColor: 'transparent',
                origin: { x: 0.5, y: 0.5 },
                width: this.backWidth - 80,
            },
        };

        const xAlingn = this.scene.game.data.langue === 'ara' ? 200 : 0;
        this.content = this.scene.createTextElement(xAlingn, 0, ans);
        this.back = this.scene.add
            .rexRoundRectangle(
                0,
                0,
                this.backWidth,
                this.backHeight,
                60 * Scales.scaleX,
                Colors.Elmt.Beige,
            )
            .setOrigin(0.5);
        // this.back = this.scene.add.rexRoundRectangle(0, 0, this.content.width + 30, this.content.height + 20, 40, Colors.Elmt.MiddleBlue).setOrigin(0.5)

        this.add(this.back);
        this.add(this.content);

        // goodLogo
        // badLogo

        this.logo = this.scene.add
            .image(
                this.scene.game.data.langue === 'ara'
                    ? this.content.x + 20 * Scales.scaleX
                    : this.content.x + this.content.width / 2 + 20 * Scales.scaleX,
                0,
                'goodLogo',
            )
            .setOrigin(0, 0.5)
            .setScale(0.6);

        this.add(this.logo);
        this.logo.setAlpha(0);
        this.setSize(this.backWidth, this.backHeight);

        this.setInteractive({ cursor: 'pointer' });

        // this.scene.input.enableDebug(this);

        this.on('pointerdown', () => {
            this.scene.answerClicked(this);
        });
    }

    selectAnswer() {
        if (this.isSelected) {
            this.setUnselected();
            this.scene.selectedAnswers = this.scene.selectedAnswers.filter(
                (answer) => answer !== this,
            );
        } else {
            this.setSelected();
            this.scene.selectedAnswers.push(this);
        }
    }

    setSelected() {
        this.isSelected = true;
        this.back.setFillStyle(Colors.Elmt.DarkBlue, 1);
        this.content.setFill(Colors.Text.White);
    }

    setUnselected() {
        this.isSelected = false;
        // ajout du changement d'état
        this.back.setFillStyle(Colors.Elmt.Beige, 1);
        this.content.setFill(Colors.Text.DarkBlue);
    }

    setTrue() {
        this.back.setFillStyle(Colors.Elmt.DarkBlue, 1);
        // this.content.setWrapMode('word')
        // this.content.setWordWrapWidth(this.backWidth - 80)
        this.content.setFill(Colors.Text.White);
        this.logo.setAlpha(1);
    }

    setFalse() {
        this.back.setFillStyle(Colors.Elmt.DarkBlue, 1);
        this.content.setFill(Colors.Text.White);
        this.logo.setTexture('badLogo');
        // this.content.setWrapMode('word')
        // this.content.setWordWrapWidth(this.backWidth - 80)
        this.logo.setAlpha(1);
    }

    setTrueForget() {
        this.back.setFillStyle(Colors.Elmt.DarkBlue, 1);
        this.content.setFill(Colors.Text.Beige);
        // this.content.setWrapMode('word')
        // this.content.setWordWrapWidth(this.backWidth - 80)
        this.logo.setAlpha(1);
        this.back.setStrokeStyle(5, Colors.Elmt.DarkBlue);
    }
}
